import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SapakimHead from "./SapakimHead";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";
import '../Styles/Sapakim/SViewAllOrders.css';

function SViewAllOrders() {
  const { UID } = useParams();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchPhone, setSearchPhone] = useState("");

  useEffect(() => {
    const fetchOrdersAndCustomers = async () => {
      try {
        const q = query(collection(db, "Orders"), where("SapakId", "==", UID));
        const querySnapshot = await getDocs(q);

        // Sort orders by orderNumber (ascending)
        const ordersList = querySnapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          .sort((a, b) => {
            const numA = parseInt(a.orderNumber) || 0;
            const numB = parseInt(b.orderNumber) || 0;
            return numA - numB;
          });

        setOrders(ordersList);

        const customerIds = [...new Set(ordersList.map(order => order.CustomerID))];
        const customerData = {};
        for (const cid of customerIds) {
          const customerDoc = await getDoc(doc(db, "Customers", cid));
          if (customerDoc.exists()) {
            customerData[cid] = customerDoc.data();
          }
        }
        setCustomers(customerData);
      } catch (err) {
        console.error("שגיאה בשליפת ההזמנות או הלקוחות:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrdersAndCustomers();
  }, [UID]);

  if (loading) return <Loading />;

  const handleViewOrder = (CDID, ORID) => {
    navigate(`/SapakimHome/${UID}/SViewCustomers/${CDID}/SViewOrder/${ORID}`);
  };

  const filteredOrders = orders.filter(order => {
    const customer = customers[order.CustomerID] || {};
    if (!searchPhone) return true;
    const searchLower = searchPhone.toLowerCase();
    const phone = customer.PhoneNumber?.toLowerCase() || "";
    const name = customer.Name?.toLowerCase() || "";
    return phone.includes(searchLower) || name.includes(searchLower);
  });

  return (
    <React.Fragment>
      <SapakimHead />
      <div className="sviewall-container" dir="rtl">
        <h1 className="sviewall-title">כל ההזמנות שלך</h1>
        <input
          type="text"
          placeholder="חיפוש לפי טלפון או שם"
          className="sviewall-search"
          value={searchPhone}
          onChange={(e) => setSearchPhone(e.target.value)}
          style={{
            width: "100%",
            padding: "0.5rem 1rem",
            fontSize: "16px",
            marginBottom: "1.5rem",
            borderRadius: "6px",
            border: "1px solid #ccc",
            boxSizing: "border-box"
          }}
        />
        {filteredOrders.length === 0 ? (
          <p className="sviewall-empty">לא נמצאו הזמנות.</p>
        ) : (
          filteredOrders.map(order => {
            const customer = customers[order.CustomerID] || {};
            return (
              <div key={order.id} className="sviewall-order-card">
                <p><span className="sviewall-label">מזהה הזמנה:</span> {order.orderNumber}</p>
                <p><span className="sviewall-label">סטטוס:</span> {order.Status}</p>
                <p><span className="sviewall-label">נוצר בתאריך:</span> {order.createdAt?.toDate().toLocaleString()}</p>
                <p><span className="sviewall-label">שם לקוח:</span> {customer.Name || "לא זמין"}</p>
                <p><span className="sviewall-label">טלפון:</span> {customer.PhoneNumber || "לא זמין"}</p>
                <button
                  className="sviewall-button"
                  onClick={() => handleViewOrder(order.CustomerID, order.id)}
                >
                  צפייה בהזמנה
                </button>
              </div>
            );
          })
        )}
      </div>
    </React.Fragment>
  );
}

export default SViewAllOrders;
